// extracted by mini-css-extract-plugin
export default {"card":"JobExpectationCard_card__aRMa1","noButton":"JobExpectationCard_noButton__bsy78"};